<div class="admin-layout">
  <div class="sidebar" [class.collapsed]="isSidebarCollapsed">
    <div class="sidebar-header">
      <div class="sidebar-header-top">
        <h1>AMBASSADOR</h1>
        <button class="toggle-btn" type="button" aria-label="Alternar menu" (click)="toggleSidebar()">
          <i class="bi bi-list"></i>
        </button>
      </div>
      <p>Gestión de contenidos</p>
    </div>

    <nav class="sidebar-nav">
      <!-- <div class="nav-item">
        <a class="nav-link" routerLink="/home" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
          <i class="bi bi-house"></i>
          <span>Inicio</span>
        </a>
      </div> -->

      <div class="nav-item">
        <button class="nav-link" type="button" (click)="toggleMenu('programas')" [class.collapsed]="!isMenuOpen('programas')" [attr.aria-expanded]="isMenuOpen('programas')">
          <i class="bi bi-file-earmark-text"></i>
          <span>Programas</span>
          <i class="bi bi-chevron-down chevron"></i>
        </button>
        <div class="nav-submenu" [class.show]="isMenuOpen('programas')" data-ap-parent="programas">
          <a class="nav-link" routerLink="/admin/program" routerLinkActive="active">
            <span>Programas</span>
          </a>
          <a class="nav-link" routerLink="/admin/program/edit" routerLinkActive="active">
            <span>Nuevo programa</span>
          </a>
        </div>
      </div>

      <div class="nav-item">
        <button class="nav-link" type="button" (click)="toggleMenu('usuarios')" [class.collapsed]="!isMenuOpen('usuarios')" [attr.aria-expanded]="isMenuOpen('usuarios')">
          <i class="bi bi-people"></i>
          <span>Usuarios</span>
          <i class="bi bi-chevron-down chevron"></i>
        </button>
        <div class="nav-submenu" [class.show]="isMenuOpen('usuarios')" data-ap-parent="usuarios">
          <a class="nav-link" routerLink="/admin/user" routerLinkActive="active">
            <span>Administradores</span>
          </a>
          <a class="nav-link" routerLink="/admin/user/edit" routerLinkActive="active">
            <span>Nuevo administrador</span>
          </a>
        </div>
      </div>

      <div class="nav-item">
        <button class="nav-link" type="button" (click)="toggleMenu('vehiculos')" [class.collapsed]="!isMenuOpen('vehiculos')" [attr.aria-expanded]="isMenuOpen('vehiculos')">
          <i class="bi-car-front"></i>
          <span>Tipos de vehículo</span>
          <i class="bi bi-chevron-down chevron"></i>
        </button>
        <div class="nav-submenu" [class.show]="isMenuOpen('vehiculos')" data-ap-parent="vehiculos">
          <a class="nav-link" routerLink="/admin/vehicle-type" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
            <span>Tipos de vehículo</span>
          </a>
          <a class="nav-link" routerLink="/admin/vehicle-type/edit" routerLinkActive="active">
            <span>Nuevo tipo de vehículo</span>
          </a>
        </div>
      </div>
    </nav>
  </div>

  <div class="main-wrapper" [class.sidebar-collapsed]="isSidebarCollapsed">
    <div class="header">
      <div class="header-left">
        <button class="toggle-btn" type="button" (click)="toggleSidebar()">
          <i class="bi bi-list"></i>
        </button>
        <h2>{{ pageTitle }}</h2>
      </div>
      <div class="header-actions">
        <button class="icon-btn" type="button" title="Cerrar sesion" (click)="logout()">
          <i class="bi bi-box-arrow-right"></i>
        </button>
      </div>
    </div>

    <div class="content-wrapper">
      <div class="content">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>